import style from '../OnboardingEgyptLuckyV1.css';
import useTranslation from '../../../../localization/i18n.context';
import Button from '../../../shared/Button/Button';
import TextField from '../../../shared/TextField/TextField';
import Title from '../../../shared/Typography/Title';
import DateField from '../../../shared/DateField/DateField';
import Alert from '../../../shared/Alert/Alert';

const StepField = {
  BIRTHDAY: 'date of birth',
  ADDRESS: 'home address',
  PROFESSION: 'profession',
};

export default function FormStep4({ onInputChange, onButtonClick, data = {} }) {
  const { t, language } = useTranslation();

  const isButtonEnabled = Object.values(StepField).every(
    field => data[field] && data[field].value && data[field].value?.trim(),
  );

  return (
    <main className={style.main}>
      <div className={style['form-content']}>
        <div className={style['form-title']}>
          <Title text={t('Enter some extra ID information')} />
        </div>
        <div className={style['form-alert']}>
          <Alert
            hasIcon
            message={t(
              'Your information must match your ID exactly or it will impact your approval',
            )}
          />
        </div>
        <div className={style['form-inputs']}>
          <div className={style['form-control']}>
            <DateField
              lang={language}
              label={t('Date of birth')}
              type="date"
              onInput={onInputChange}
              value={data[StepField.BIRTHDAY]?.value}
              name={StepField.BIRTHDAY}
            />
          </div>

          <div className={style['form-control']}>
            <TextField
              label={t('Home address')}
              placeholder={t('E.g. 16 Saray El Gazira Street')}
              onInput={onInputChange}
              value={data[StepField.ADDRESS]?.value}
              name={StepField.ADDRESS}
            />
          </div>

          <div className={style['form-control']}>
            <TextField
              label={t('Profession')}
              onInput={onInputChange}
              value={data[StepField.PROFESSION]?.value}
              name={StepField.PROFESSION}
            />
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button fullWidth disabled={!isButtonEnabled} onClick={onButtonClick}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
FormStep4.Type = 'FormStep4';
FormStep4.EventName = 'Extra_step';
